// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 3L1 3L1 21H23V3ZM19.9142 10.5L15 15.4142L12.0858 12.5L13.5 11.0858L15 12.5858L18.5 9.08579L19.9142 10.5ZM11 17H5L5 15H11V17ZM11 9L5 9V7L11 7V9ZM11 13H5V11H11V13Z"}}]};

const FactCheckFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'fact-check-filled',
    ref,
    icon: element,
  },
));

FactCheckFilledIcon.displayName = 'FactCheckFilledIcon';

export default FactCheckFilledIcon;
